import * as angular from "angular";
import {IController} from "angular";

export class BringozProgressLinearComponent implements IController {
  value: any;
  bufferValue: any;
  size: any;
  isCapacity: any;
  isProgress: any;
  showValue: any;
  isColumn: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozProgressLinear', {
    bindings: {
      value: '<',
      bufferValue: '<',
      size: '@?',
      isCapacity: '@?',
      isProgress: '@?',
      showValue: '<?',
      isColumn: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-progress-linear/bringoz-progress-linear.html',
    controller: BringozProgressLinearComponent
  });
